import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarFull } from '../TopBarFull';
import {
  TopBarFullCtaColors,
  TopBarFullUseCaseEnums,
} from '../TopBarFullEnums';
import quizzesImage from '../assets/UCS_Quizzes_Assessments.png';

const DEFAULT_UTSOURCE2 = 'full_misc_upsell_quizzes_assessments';
const DEFAULT_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.headline',
    defaultMessage: 'Share customized feedback with Quizzes Pro',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.message',
    defaultMessage:
      'Display quiz feedback based on answer accuracy. Then email the scores.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.ctaText',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const INITIATED_DRAFTED_UTSOURCE2 = 'full_initiate_upsell_quizzes_assessments';
const INITIATED_DRAFTED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.headlineInitiated',
    defaultMessage: 'Share customized feedback with Quizzes Pro',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.messageInitiated',
    defaultMessage:
      'Display quiz feedback based on answer accuracy. Then email the scores.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.ctaTextInitiated',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const TESTED_ACTIVATED_UTSOURCE2 = 'full_activate_upsell_quizzes_assessments';
const TESTED_ACTIVATED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.headlineTested',
    defaultMessage: `See everyone's scores with unlimited responses`,
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.messageTested',
    defaultMessage: `Your plan shows the first 100 scores. Unlock the rest with an upgraded plan.`,
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.ctaTextTested',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const DEPLOYED_UTSOURCE2 = 'full_deploy_upsell_quizzes_assessments';
const DEPLOYED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.headlineDeployed',
    defaultMessage: 'Export & save results for better record-keeping',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.messageDeployed',
    defaultMessage:
      'Keep a history of how quiz-takers performed with advanced export options.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseQuizzesAssessmentsTopBarFull.ctaTextDeployed',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

export type UseCaseQuizzesAssessmentsTopBarFullProps = {
  variation?: TopBarFullUseCaseEnums | null;
};

const VariationToCopy = {
  [TopBarFullUseCaseEnums.InitiatedDrafted]: {
    copy: INITIATED_DRAFTED_COPY,
    utSource2: INITIATED_DRAFTED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.TestedActivated]: {
    copy: TESTED_ACTIVATED_COPY,
    utSource2: TESTED_ACTIVATED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.Deployed]: {
    copy: DEPLOYED_COPY,
    utSource2: DEPLOYED_UTSOURCE2,
  },
};

export const UseCaseQuizzesAssessmentsTopBarFull: React.FC<UseCaseQuizzesAssessmentsTopBarFullProps> = ({
  variation,
}) => {
  const [copy, utSource2] =
    variation && variation in VariationToCopy
      ? [VariationToCopy[variation].copy, VariationToCopy[variation].utSource2]
      : [DEFAULT_COPY, DEFAULT_UTSOURCE2];
  return (
    <TopBarFull
      headline={t(copy.HEADLINE)}
      message={t(copy.MESSAGE)}
      image={() => <img src={quizzesImage} aria-hidden="true" />}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL('/pricing/upgrade/', {
        ut_source: 'topbar',
        ut_source2: utSource2,
      })}
      ctaNewTab={true}
      ctaColor={TopBarFullCtaColors.alt}
    />
  );
};

export default UseCaseQuizzesAssessmentsTopBarFull;
